import { render, staticRenderFns } from "./info-block.vue?vue&type=template&id=4a7d626f&scoped=true"
import script from "./info-block.vue?vue&type=script&lang=js"
export * from "./info-block.vue?vue&type=script&lang=js"
import style0 from "./info-block.vue?vue&type=style&index=0&id=4a7d626f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d626f",
  null
  
)

export default component.exports